import { render, staticRenderFns } from "./AlarmIcon.vue?vue&type=template&id=07c80305&"
import script from "./AlarmIcon.vue?vue&type=script&lang=js&"
export * from "./AlarmIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports